import { render } from "./VirtualMeetingOptions.vue?vue&type=template&id=a0789d60&scoped=true&ts=true"
import script from "./VirtualMeetingOptions.vue?vue&type=script&lang=ts"
export * from "./VirtualMeetingOptions.vue?vue&type=script&lang=ts"

import "./VirtualMeetingOptions.vue?vue&type=style&index=0&id=a0789d60&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0789d60"]])

export default __exports__